import styled from "styled-components";
import { Colors } from "~/config/Colors";

export const Container = styled.div`
  position: relative;

  input {
    padding-left: 2.5rem;
  }

  i {
    position: absolute;
    left: 0.4rem;
    top: 0.3rem;
    color: #fff;
  }

`;

export const InputCustom = styled.input`
  color: ${Colors.Color7} !important;

  ${({ notForm }) => {
    if (notForm == true) {
      return `
        background-color: ${Colors.Color13};
        color: ${Colors.Color7} !important;
      `;
    } else {
      return `
        background-color: ${Colors.Color23};
        color: ${Colors.Color7} !important;
      `;
    }
  }}

  font-size: 0.8rem;
  line-height: 1rem;
  width: 20rem;
  max-width: 100%;
  height: 2.5rem;
  border: 0;
  border-radius: 0.625rem;
  padding: 0em 1rem;
  align-self: center;

  &::placeholder {
    color: ${Colors.Color7} !important;
  }

  &:read-only {
    background-color: ${Colors.Color12};
    border: 0.1rem solid ${Colors.Color12};
  }

  &:disabled {
    background-color: ${Colors.Color12};
    border: 0.1rem solid ${Colors.Color12};
  }

  :focus,
  :hover {
    // border: 0.1rem solid ${Colors.Color4};
  }
`;
